import {forwardRef, useImperativeHandle, useState} from "react";
import {ConfigProvider, Modal, Tooltip} from "antd";
import {IconClose, IconCloseBlackImage} from "../../Icon";
import {getImagePathWithTheme, imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import style from "./DialogDesktopPro.module.scss";
import {
    DESKTOP_PRO_FROM_IMPORT_FILE,
    DESKTOP_PRO_FROM_IMPORT_FONT, DESKTOP_PRO_FROM_LASER_POINTER,
    DESKTOP_PRO_FROM_OCR,
    DESKTOP_PRO_FROM_PDF_ANNO, DESKTOP_PRO_FROM_REMOVE_WATERMARK
} from "@/Const";
import {t} from "i18next";
import {ipcSend} from "@/common/ipc";
import DesktopProItem from "@/views/Draw/DesktopProItem";
import {isZh} from "@/language";

const DialogDesktopPro = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));

    const ARRAY_DESKTOP_PROS = [
        {
            id:DESKTOP_PRO_FROM_IMPORT_FILE,
            icon:'desktop_pro_file',
            label:t('Import local files'),
            isSelected:false,
            tips:t('ImportLocalFilesTip'),
        },
        {
            id:DESKTOP_PRO_FROM_IMPORT_FONT,
            icon:'desktop_pro_font',
            label:t('Import custom fonts'),
            isSelected:false,
            tips:t('ImportCustomFontsTip')
        },
        // {
        //     id:DESKTOP_PRO_FROM_PDF_ANNO,
        //     icon:'desktop_pro_pdf_anno',
        //     label:t('PDf Annotations'),
        //     isSelected:false,
        //     tips:t('PdfAnnoTip')
        // },
        {
            id:DESKTOP_PRO_FROM_OCR,
            icon:'desktop_pro_ocr',
            label:t('OCR Image to text'),
            isSelected:false,
            tips:t('OcrImageToTextTip')
        },
        {
            id:DESKTOP_PRO_FROM_LASER_POINTER,
            icon:'desktop_pro_laser_pointer',
            label:t('Laser pointer'),
            isSelected:false,
            tips:t('LaserPointerTip')
        },
        {
            id:DESKTOP_PRO_FROM_REMOVE_WATERMARK,
            icon:'desktop_pro_pdf_remove_watermark',
            label:t('Remove watermark'),
            isSelected:false,
            tips:t('RemoveWatermarkTip')
        }
    ]

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayDesktopPros,setArrayDesktopPros] = useState(ARRAY_DESKTOP_PROS);

    const onShowDialog = (szFrom:string)=>{
        setIsShowDialog(true);
        var arrayDatas = [...ARRAY_DESKTOP_PROS];

        arrayDatas.forEach(p=>{
            if (p.id == szFrom){
                p.isSelected = true;
            }
        })
        setArrayDesktopPros(arrayDatas);
    }

    const getPricingCollection = ()=>{
        const arrayPricing:any[] = [
            {
                id:'free',
                title:t("Free"),
                price:0,
                subTitle:t("FreeSubTitle"),
                buttonText:t("Continue"),
                infoTitle:t("Visual space with"),
                subInfo:[
                    {title:t("Up to 5 local projects")},
                    {title:t("All visual creation features")},
                    {title:t("Pdf annotations")},
                    {title:t("No account or signup required")}
                ]
            },
            {
                id:'desktopPro',
                title:t("DesktopPro"),
                price:49,
                originPrice:99,
                subTitle:t("Pay-once license for you"),
                buttonText:t("Buy license"),
                infoTitle:t("Include Free plan and"),
                subInfo:[
                    {title:t("One device"),tips:t("UpToDevicesCanBe")},
                    {title:t("Unlimited local projects")},
                    {title:t("Export project with local files"),tips:t("ExportProjectTips1")},
                    {title:t("Import local files")},
                    {title:t("OCR Image to text")},
                    {title:t("Laser pointer")},
                    {title:t("Remove watermark")},

                    {title:t("Pay once, use forever")},
                ]
            },
            {
                id:'desktopProPlus',
                title:t("DesktopProPlus"),
                price:99,
                originPrice:199,
                subTitle:t("GreatForMulti"),
                buttonText:t("Buy license"),
                infoTitle:t("Include Free plan and"),
                subInfo:[
                    {title:t("Five device"),tips:t("UpToDevicesCanBe").replace("2","6")},
                    {title:t("Unlimited local projects")},
                    {title:t("Export project with local files"),tips:t("ExportProjectTips1")},
                    {title:t("Import local files")},
                    {title:t("OCR Image to text")},
                    {title:t("Laser pointer")},
                    {title:t("Remove watermark")},

                    {title:t("Pay once, use forever")},
                ]
            }
        ]

        return arrayPricing;
    }

    return(
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        /* 这里是你的组件 token */
                        contentBg:'#FFFDF7'
                    },
                },
            }}
        >
            {/*1.4*/}
            <Modal width={'1129px'} bodyStyle={{height:'776px',margin:'-20px -24px -32px -24px',color:'#333333'}} centered={true} closeIcon={<IconCloseBlackImage/>} footer={''} open={isShowDialog} onCancel={()=>setIsShowDialog(false)}>
                <>
                    <div className={'flex-column-center'} style={{marginTop:'56px'}}>
                        <span className={'font-family-semi-bold'} style={{fontSize:'40px'}}>{t('Pricing')}</span>
                        <span style={{fontSize:'20px',marginTop:'8px'}}>{t("SupportABootstrapped")}</span>
                    </div>
                    <div className={'flex-center mt-6 font-family-semi-bold'}>
                        <img className={'img-24'} src={imgPathPerfix()+'desktoppro_info.png'}/>
                        <span className={'ml-2 mt-2'}>{t("MoneyBackGuarantee")}</span>
                    </div>
                    {/*1.7*/}
                    <div className={'flex-row-vertical-center'} style={{marginTop:'42px',padding:'0 26px',height:'565px'}}>
                        {
                            getPricingCollection().map(p=>{
                                return(
                                    <DesktopProItem key={p.id} priceItem={p} onButtonClicked={(priceItem:any)=>{
                                        if (priceItem.id == 'free') {
                                            setIsShowDialog(false);
                                        }else {
                                            if (isZh()) {
                                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH);
                                            }else {
                                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                            }
                                        }
                                    }}/>
                                )
                            })
                        }
                    </div>
                    {/*<div style={{position: 'relative'}}>*/}
                    {/*    <img style={{width: '100%', height: '100%'}} src={getImagePathWithTheme('desktop_pro_bg')}/>*/}
                    {/*    <div style={{*/}
                    {/*        position: "absolute",*/}
                    {/*        left: '0px',*/}
                    {/*        top: '60px',*/}
                    {/*        padding: '0 46px',*/}
                    {/*        height: '100%'*/}
                    {/*    }}>*/}
                    {/*        <div className={'flex-row-vertical-center'}>*/}
                    {/*            <span className={'font-family-semi-bold'} style={{fontSize: '28px'}}>Desktop</span>*/}
                    {/*            <span className={style.deskTopPro}>PRO</span>*/}
                    {/*        </div>*/}

                    {/*        <div style={{height:'32px'}}></div>*/}
                    {/*        {*/}
                    {/*            arrayDesktopPros.map(p => {*/}
                    {/*                return (*/}
                    {/*                    <div className={'flex-row-vertical-center ' + style.deskTopItem} style={{background:(p.isSelected?'#F6F6F6':'transparent')}}>*/}
                    {/*                        <img style={{width: '26px', height: '26px'}}*/}
                    {/*                             src={getImagePathWithTheme(p.icon)}/>*/}
                    {/*                        <span className={'ml-8'}>{p.label}</span>*/}
                    {/*                        {*/}
                    {/*                            !isStringNullOrEmpty(p.tips) &&*/}
                    {/*                            <Tooltip title={p.tips} placement={"right"}>*/}
                    {/*                                <img className={'img-14 ml-6'}*/}
                    {/*                                     src={getImagePathWithTheme('desktop_pro_tip')}/>*/}
                    {/*                            </Tooltip>*/}
                    {/*                        }*/}

                    {/*                    </div>*/}
                    {/*                )*/}
                    {/*            })*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<div className={'flex-center cursor-pointer button-solid-style '+style.desktopProBuy} onClick={()=>{*/}
                    {/*    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);*/}
                    {/*}}>*/}
                    {/*    <span style={{color:"white",fontSize:'18px',fontFamily: 'PoppinsMedium'}}>{t("Buy Desktop PRO")}</span>*/}
                    {/*</div>*/}
                </>

            </Modal>

        </ConfigProvider>
    )
});

export default DialogDesktopPro;
















